import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStructuralIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 103,
	height: 106,
	viewBox: "0 0 103 106",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 3.00006,
			y1: 24,
			x2: 3.00006,
			y2: 105,
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71 20L72 105",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 610352e-10,
			y1: 22,
			x2: 70.0001,
			y2: 22,
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 30.0001,
			y1: 3,
			x2: 100,
			y2: 3,
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 610352e-10,
			y1: 102,
			x2: 70.0001,
			y2: 102,
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 610352e-10,
			y1: 62,
			x2: 70.0001,
			y2: 62,
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.1569 26.0337L4.5 60.4999",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.1796 66.5142L4.5 99.9999",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -3,
			x2: 53.207,
			y2: -3,
			transform: "matrix(0.648543 0.761178 -0.66364 0.748052 35.2113 24.5603)",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -3,
			x2: 52.5931,
			y2: -3,
			transform: "matrix(0.656114 0.754662 -0.656114 0.754662 35.2113 65.0603)",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.0626 22.8982L99.5 3",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.5 21.5L32.5 1.99995",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -3,
			x2: 35.1543,
			y2: -3,
			transform: "matrix(0.841361 -0.540474 0.786692 0.617346 70.4226 64.7502)",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.5 103L99.5 85",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99 0L99 86.9175",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -3,
			x2: 52.3453,
			y2: -3,
			transform: "matrix(0.295976 -0.955195 0.98802 0.154329 70.4226 64.7502)",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.7349 104.197L85.2113 54.7502",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.2115 14.2503L99.2619 44.5969",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.2114 54.2503L99 84",
			stroke: "currentColor",
			strokeWidth: 6
		})
	]
});
export default SvgStructuralIcon;
